import { NavigationServiceConfiguration, PageDefinition } from "@cervval.js/client-html5-spa/navigation";
import { ObjectTools } from "@cervval.js/common/tools";

type MenuUid = string;

/**
 * Map of the pages of the application by pageName
 */
const pages = {
    "login": ObjectTools.is<PageDefinition<MenuUid>>({
        importPromise: () => { return import("./login/login.page").then((module) => new module.LoginPage()); }

    }),
    "disconnected": ObjectTools.is<PageDefinition<MenuUid>>({
        importPromise: () => { return import("./disconnected/disconnected.page").then((module) => new module.DisconnectedPage()); }

    })
};

const allPages = { ...pages };
export type PageName = keyof typeof allPages;

/**
 * @returns the navigation service configuration
 */
export function getNavigationServiceConfiguration(): NavigationServiceConfiguration<PageName> {
    const conf: NavigationServiceConfiguration<PageName> = {
        pages: allPages,
        defaultPage: "login"
    };
    return conf;
}